module.exports = __webpack_public_path__ + "img/button_guide.139faf54.jpg";